/**
 * Applications source names used when getting total values from stored procdure `getEndOfDayReportSource`
 */
export enum ApplicationSourceNameEnum {
  JUST_EAT = 'JUST EAT',
  DELIVEROO = 'DELIVEROO',
  UBER = 'UBER',
  CARD_ONLINE = 'Card Online (UpCo Online)'
}

